import { useEffect, useState } from 'react'

/**
 * Drives a step-based animation timeline. Returns the current step index,
 * starting at 0 and advancing to 1, 2, 3 … after each delay (in ms) elapses.
 * Resets whenever `active` flips, so slide animations replay on re-entry.
 */
export function useSequence(delays: number[], active: boolean = true): number {
  const [step, setStep] = useState(0)
  const key = delays.join(',')

  useEffect(() => {
    setStep(0)
    if (!active) return
    let elapsed = 0
    const timers = delays.map((delay, index) => {
      elapsed += delay
      return window.setTimeout(() => setStep(index + 1), elapsed)
    })
    return () => timers.forEach((timer) => window.clearTimeout(timer))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active, key])

  return step
}
